import { useEffect, useState } from "react";

interface ConfettiPiece {
  id: number;
  x: number;
  delay: number;
  duration: number;
  color: string;
  size: number;
  rotation: number;
}

const COLORS = [
  "#FF6B9D", // pop pink
  "#FFD93D", // gold
  "#6BCB77", // green
  "#4D96FF", // blue
  "#FF6B6B", // coral
  "#C9B1FF", // lavender
];

const VideoUnlockConfetti = ({ show }: { show: boolean }) => {
  const [pieces, setPieces] = useState<ConfettiPiece[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (show) {
      // Generate confetti pieces
      const newPieces: ConfettiPiece[] = Array.from({ length: 30 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        delay: Math.random() * 0.5,
        duration: 1.5 + Math.random() * 1,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        size: 6 + Math.random() * 6,
        rotation: Math.random() * 360,
      }));
      
      setPieces(newPieces);
      setIsVisible(true);

      // Clean up after animation
      const timer = setTimeout(() => {
        setIsVisible(false);
        setPieces([]);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!isVisible || pieces.length === 0) return null;

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-50">
      {pieces.map((piece) => (
        <div
          key={piece.id}
          className="absolute animate-confetti-fall"
          style={{
            left: `${piece.x}%`,
            top: "-10px",
            width: piece.size,
            height: piece.size,
            backgroundColor: piece.color,
            borderRadius: Math.random() > 0.5 ? "50%" : "2px",
            transform: `rotate(${piece.rotation}deg)`,
            animationDelay: `${piece.delay}s`,
            animationDuration: `${piece.duration}s`,
          }}
        />
      ))}
      
      {/* Celebration text */}
      <div className="absolute inset-x-0 top-1/3 flex justify-center animate-bounce-in">
        <div className="px-4 py-2 rounded-full bg-gradient-to-r from-pop to-pink-500 text-white text-sm font-medium shadow-lg">
          🎉 All videos unlocked!
        </div>
      </div>
    </div>
  );
};

export default VideoUnlockConfetti;
